import { Content } from "@/services/content/types";
import { textContent } from "@/utils/jsx";
import { prefixSlug } from "@/utils/url";
import { PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import FormatDate from "../format-date";
import ShareButtons from "../share-buttons";

type ItemProps = {
  post: Content.LiveReportPost;
  article: Content.Article;
};

const Item = (props: PropsWithChildren<ItemProps>) => {
  const shareUrl =
    process.env.NEXT_PUBLIC_FRONTEND_URL +
    prefixSlug(
      props.article.fields.slug,
      props.article.sys.contentType.sys.id,
    ) +
    `?post=${props.post.id}&source=&utm_source=efn.se&utm_medium=Web&utm_content=&utm_campaign=Internal`;

  const avatar = props.post.author?.fields?.image;
  const title =
    props.post.heading?.props?.children?.map(textContent).join("") || "";
  return (
    <div className={"relative flex flex-col items-start"}>
      <div className={"flex items-center gap-2 w-full"}>
        {avatar?.fields.file?.url && (
          <img
            src={
              avatar.fields.file.url + "?crop=1:1,smart&width=200&trim=0,0.2"
            }
            alt={props.post.author.fields.name}
            className="w-12 h-12 rounded-full bg-static-sand-600 border-1 border-static-sand-800 p-1 -ml-6"
          />
        )}
        {!avatar?.fields.file?.url && (
          <div className="w-4 h-4 rounded-full shadow-xlg bg-sand-900 p-1 -ml-2" />
        )}

        {props.post.author && (
          <span className="block">{props.post.author.fields.name}</span>
        )}

        <div>
          <FormatDate date={props.post.date} format="relative" />{" "}
          <FormatDate date={props.post.date} format="time" />
        </div>

        <div className="ml-autxo">
          <ShareButtons url={shareUrl} shareText="" title={title} />
        </div>
      </div>

      <div className="border-l-2 border-sand-600 pl-6 py-4">
        <ErrorBoundary
          fallbackRender={(e) => {
            console.error(e);
            return <div>Något gick fel när det här inlägget skulle visas.</div>;
          }}
        >
          {props.post.jsx}
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default Item;
